import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import About from '@/views/about.vue'
import Service from '@/views/service.vue'
import ServiceDetail from '@/views/serviceDetail.vue'
import Case from '@/views/case.vue'
import CaseDetail from '@/views/caseDetail.vue'
import News from '@/views/news.vue'
import NewsDetail from '@/views/newsDetail.vue'
import Contact from '@/views/contact.vue'
import Join from '@/views/join.vue'


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            auth: true,
            keepAlive: false,
            title: '北京春溢通物流有限公司 ',
            content:{
                keywords:'春溢通物流，北京物流，华北物流，仓储服务，市内配送，搬家服务，现代化管理系统，ISO9001 质量体系认证，专业团队，绿色车队，个性化服务',
                description:'北京春溢通物流有限公司，专注物流领域。凭借现代化管理系统与专业团队，提供全面服务。涵盖仓储服务，以精准管理确保货物妥善存放；市内配送高效及时，保障货物快速送达；特色搬家服务贴心专业。作为通过 ISO9001 质量体系认证企业，服务品质有保障。拥有北京奥运保障绿色车队资质，践行环保理念。针对不同客户需求，提供个性化方案，致力于为北京及华北地区客户打造一站式、高品质的物流体验 。',
            },
        }
    },
    {
        path: '/about',
        name: 'About',
        component: About,
        meta: {
            auth: true,
            keepAlive: false,
            title: '关于我们-北京春溢通物流有限公司',
            content:{
                keywords:'春溢通物流，北京物流，华北物流，仓储服务，市内配送，搬家服务，现代化管理系统，ISO9001 质量体系认证，专业团队，绿色车队，个性化服务',
                description:'北京春溢通物流有限公司，专注物流领域。凭借现代化管理系统与专业团队，提供全面服务。涵盖仓储服务，以精准管理确保货物妥善存放；市内配送高效及时，保障货物快速送达；特色搬家服务贴心专业。作为通过 ISO9001 质量体系认证企业，服务品质有保障。拥有北京奥运保障绿色车队资质，践行环保理念。针对不同客户需求，提供个性化方案，致力于为北京及华北地区客户打造一站式、高品质的物流体验 。',
            },
        }
    },
    {
        path: '/service',
        name: 'Service',
        component: Service,
        meta: {
            auth: true,
            keepAlive: false,
            title: '业务与服务-北京春溢通物流有限公司',
            content:{
                keywords:'春溢通物流，北京物流，华北物流，仓储服务，市内配送，搬家服务，现代化管理系统，ISO9001 质量体系认证，专业团队，绿色车队，个性化服务',
                description:'北京春溢通物流有限公司，专注物流领域。凭借现代化管理系统与专业团队，提供全面服务。涵盖仓储服务，以精准管理确保货物妥善存放；市内配送高效及时，保障货物快速送达；特色搬家服务贴心专业。作为通过 ISO9001 质量体系认证企业，服务品质有保障。拥有北京奥运保障绿色车队资质，践行环保理念。针对不同客户需求，提供个性化方案，致力于为北京及华北地区客户打造一站式、高品质的物流体验 。',
            },
        }
    },
    {
        path: '/servicedetail',
        name: 'ServiceDetail',
        component: ServiceDetail,
        meta: {
            auth: true,
            keepAlive: false,
            title: '业务与服务详情-北京春溢通物流有限公司',
            content:{
                keywords:'春溢通物流，北京物流，华北物流，仓储服务，市内配送，搬家服务，现代化管理系统，ISO9001 质量体系认证，专业团队，绿色车队，个性化服务',
                description:'北京春溢通物流有限公司，专注物流领域。凭借现代化管理系统与专业团队，提供全面服务。涵盖仓储服务，以精准管理确保货物妥善存放；市内配送高效及时，保障货物快速送达；特色搬家服务贴心专业。作为通过 ISO9001 质量体系认证企业，服务品质有保障。拥有北京奥运保障绿色车队资质，践行环保理念。针对不同客户需求，提供个性化方案，致力于为北京及华北地区客户打造一站式、高品质的物流体验 。',
            },
        }
    },
    {
        path: '/case',
        name: 'Case',
        component: Case,
        meta: {
            auth: true,
            keepAlive: false,
            title: '经典案例-北京春溢通物流有限公司',
            content:{
                keywords:'春溢通物流，北京物流，华北物流，仓储服务，市内配送，搬家服务，现代化管理系统，ISO9001 质量体系认证，专业团队，绿色车队，个性化服务',
                description:'北京春溢通物流有限公司，专注物流领域。凭借现代化管理系统与专业团队，提供全面服务。涵盖仓储服务，以精准管理确保货物妥善存放；市内配送高效及时，保障货物快速送达；特色搬家服务贴心专业。作为通过 ISO9001 质量体系认证企业，服务品质有保障。拥有北京奥运保障绿色车队资质，践行环保理念。针对不同客户需求，提供个性化方案，致力于为北京及华北地区客户打造一站式、高品质的物流体验 。',
            },
        }
    },
    {
        path: '/casedetail',
        name: 'CaseDetail',
        component: CaseDetail,
        meta: {
            auth: true,
            keepAlive: false,
            title: '经典案例详情-北京春溢通物流有限公司',
            content:{
                keywords:'春溢通物流，北京物流，华北物流，仓储服务，市内配送，搬家服务，现代化管理系统，ISO9001 质量体系认证，专业团队，绿色车队，个性化服务',
                description:'北京春溢通物流有限公司，专注物流领域。凭借现代化管理系统与专业团队，提供全面服务。涵盖仓储服务，以精准管理确保货物妥善存放；市内配送高效及时，保障货物快速送达；特色搬家服务贴心专业。作为通过 ISO9001 质量体系认证企业，服务品质有保障。拥有北京奥运保障绿色车队资质，践行环保理念。针对不同客户需求，提供个性化方案，致力于为北京及华北地区客户打造一站式、高品质的物流体验 。',
            },
        }
    },
    {
        path: '/news',
        name: 'News',
        component: News,
        meta: {
            auth: true,
            keepAlive: false,
            title: '新闻资讯-北京春溢通物流有限公司',
            content:{
                keywords:'春溢通物流，北京物流，华北物流，仓储服务，市内配送，搬家服务，现代化管理系统，ISO9001 质量体系认证，专业团队，绿色车队，个性化服务',
                description:'北京春溢通物流有限公司，专注物流领域。凭借现代化管理系统与专业团队，提供全面服务。涵盖仓储服务，以精准管理确保货物妥善存放；市内配送高效及时，保障货物快速送达；特色搬家服务贴心专业。作为通过 ISO9001 质量体系认证企业，服务品质有保障。拥有北京奥运保障绿色车队资质，践行环保理念。针对不同客户需求，提供个性化方案，致力于为北京及华北地区客户打造一站式、高品质的物流体验 。',
            },
        }
    },
    {
        path: '/newsdetail',
        name: 'NewsDetail',
        component: NewsDetail,
        meta: {
            auth: true,
            keepAlive: false,
            title: '新闻资讯详情-北京春溢通物流有限公司',
            content:{
                keywords:'春溢通物流，北京物流，华北物流，仓储服务，市内配送，搬家服务，现代化管理系统，ISO9001 质量体系认证，专业团队，绿色车队，个性化服务',
                description:'北京春溢通物流有限公司，专注物流领域。凭借现代化管理系统与专业团队，提供全面服务。涵盖仓储服务，以精准管理确保货物妥善存放；市内配送高效及时，保障货物快速送达；特色搬家服务贴心专业。作为通过 ISO9001 质量体系认证企业，服务品质有保障。拥有北京奥运保障绿色车队资质，践行环保理念。针对不同客户需求，提供个性化方案，致力于为北京及华北地区客户打造一站式、高品质的物流体验 。',
            },
        }
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact,
        meta: {
            auth: true,
            keepAlive: false,
            title: '联系我们-北京春溢通物流有限公司',
            content:{
                keywords:'春溢通物流，北京物流，华北物流，仓储服务，市内配送，搬家服务，现代化管理系统，ISO9001 质量体系认证，专业团队，绿色车队，个性化服务',
                description:'北京春溢通物流有限公司，专注物流领域。凭借现代化管理系统与专业团队，提供全面服务。涵盖仓储服务，以精准管理确保货物妥善存放；市内配送高效及时，保障货物快速送达；特色搬家服务贴心专业。作为通过 ISO9001 质量体系认证企业，服务品质有保障。拥有北京奥运保障绿色车队资质，践行环保理念。针对不同客户需求，提供个性化方案，致力于为北京及华北地区客户打造一站式、高品质的物流体验 。',
            },
        }
    },
    {
        path: '/join',
        name: 'Join',
        component: Join,
        meta: {
            auth: true,
            keepAlive: false,
            title: '加入我们-北京春溢通物流有限公司',
            content:{
                keywords:'春溢通物流，北京物流，华北物流，仓储服务，市内配送，搬家服务，现代化管理系统，ISO9001 质量体系认证，专业团队，绿色车队，个性化服务',
                description:'北京春溢通物流有限公司，专注物流领域。凭借现代化管理系统与专业团队，提供全面服务。涵盖仓储服务，以精准管理确保货物妥善存放；市内配送高效及时，保障货物快速送达；特色搬家服务贴心专业。作为通过 ISO9001 质量体系认证企业，服务品质有保障。拥有北京奥运保障绿色车队资质，践行环保理念。针对不同客户需求，提供个性化方案，致力于为北京及华北地区客户打造一站式、高品质的物流体验 。',
            },
        }
    },

]

const router = new VueRouter({
    mode: 'history',
    scrollBehavior: () => ({y: 0}),
    routes
})

export default router
